import { render } from "./CardFixGlass.vue?vue&type=template&id=4b33e359&scoped=true&ts=true"
import script from "./CardFixGlass.vue?vue&type=script&lang=ts"
export * from "./CardFixGlass.vue?vue&type=script&lang=ts"

import "./CardFixGlass.vue?vue&type=style&index=0&id=4b33e359&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b33e359"]])

export default __exports__